import { ReactNode, useMemo } from 'react'

import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import {
  ColorSchemeProvider,
  ThemeProvider,
  calculateColorSchemeMode,
} from '@tribeplatform/react-ui-kit/ThemeProvider'

import { AppInitialProps } from '../../@types/index.js'
import { convertNetworkToAppearance } from '../new-themes/utils.js'

export type WebThemeProviderProps = {
  children?: ReactNode
  pageProps: AppInitialProps
}

/**
 *
 */
export const WebThemeProvider = ({
  children,
  pageProps,
}: WebThemeProviderProps) => {
  const {
    data: { network },
  } = useAuthToken()

  const appearance = useMemo(() => {
    return convertNetworkToAppearance(network)
  }, [network])

  const colorSchemeMode = useMemo(
    () =>
      calculateColorSchemeMode({
        userColorScheme: pageProps.colorScheme,
        networkColorScheme: appearance.networkColorScheme,
      }),
    [appearance, pageProps.colorScheme],
  )

  return (
    <ColorSchemeProvider colorSchemeMode={colorSchemeMode}>
      <ThemeProvider
        theme={appearance.theme}
        typography={appearance.typography}
        style={appearance.style}
        networkColorScheme={appearance.networkColorScheme}
      >
        {children}
      </ThemeProvider>
    </ColorSchemeProvider>
  )
}
